import React, {PropTypes} from 'react';
import Select from 'react-select';
import ScheduleEventListContainer from './ScheduleEventListContainer.jsx';
import RegistrationCalendarContainer from './RegistrationCalendarContainer.jsx';
import EventPriceDetailsModalContainer from 'shared/eventPriceDetailsModal/EventPriceDetailsModalContainer.jsx';
import VirtualEventContainer from './VirtualEventContainer.jsx';
import CartFooterContainer from './CartFooterContainer.jsx';

const ReserveSquads = ({
  noDatesAvailable,
  tournamentId,
  tournamentName,
  tournaments,
  onTournamentChange
}) => (
  <div className="animated fadeIn">
    <div className="row">
      <div className="col-md-4">
        <div className="form-group">
          <label htmlFor="activeTournaments">{'Select Tournament'}</label>
          <Select
            name="activeTournaments"
            options={tournaments}
            simpleValue
            searchable
            value={tournamentId}
            onChange={value => onTournamentChange(value)}
          />
        </div>
      </div>
      <div className="col-md-8">
        <h2 className="text-center">{tournamentName}</h2>
      </div>
    </div>
    <div className="row">
      <div className="col-md-12">
        {
          noDatesAvailable
          ? <div className="alert alert-info animated fadeIn">{'No dates available for this tournament.'}</div>
          : null
        }
      </div>
    </div>
    {
      noDatesAvailable
      ? <div>
          <VirtualEventContainer />
          <CartFooterContainer />
        </div>
      : <div>
          <div className="row">
            <div className="col-md-4">
              <RegistrationCalendarContainer />
            </div>
            <div className="col-md-8">
              <ScheduleEventListContainer />
              <VirtualEventContainer />
              <CartFooterContainer />
            </div>
          </div>
          <EventPriceDetailsModalContainer />
        </div>
    }
  </div>
);

ReserveSquads.propTypes = {
  noDatesAvailable: PropTypes.bool,
  tournamentId: PropTypes.string,
  tournamentName: PropTypes.string,
  tournaments: PropTypes.arrayOf(PropTypes.object),
  onTournamentChange: PropTypes.func
};

ReserveSquads.defaultProps = {
  noDatesAvailable: false,
  tournamentId: null,
  tournamentName: '',
  tournaments: []
};

export default ReserveSquads;



// WEBPACK FOOTER //
// ./src/features/admin/schedule/ReserveSquads.jsx